import {LoaderFunction, redirect} from 'react-router';
import {APP_PATH, UNAVAILABLE_PATH} from '@/constants/routes';
import {PREVIOUS_PATH_KEY} from '@/constants/storage';
import {logger} from '@/initializers/logger';
import AuthenticationServiceInstance from '@/services/authentication';

export const CallbackLoader: LoaderFunction = async ({request}) => {
  const searchParams = new URL(request.url).searchParams;
  const user = await AuthenticationServiceInstance.getCurrentUser();

  const isAuthenticated = !!user;

  const codeParam = searchParams.get('code');
  const stateParam = searchParams.get('state');

  const nextPath = sessionStorage.getItem(PREVIOUS_PATH_KEY) || APP_PATH;

  if (isAuthenticated) {
    return redirect(nextPath);
  }

  if (codeParam && stateParam) {
    try {
      await AuthenticationServiceInstance.handleCallback(window.location.toString());
      return redirect(nextPath);
    } catch (error) {
      logger.error('Error handling authentication callback:', error);
      return redirect(UNAVAILABLE_PATH);
    }
  }

  return await AuthenticationServiceInstance.login();
};
